// Profiles table access — Phase B.
//
// Expected `profiles` schema (Supabase):
//   id             uuid  PK, FK → auth.users(id)  DEFAULT auth.uid()
//   email          text
//   first_name     text
//   last_name      text
//   phone          text
//   address_line1  text
//   address_line2  text
//   city           text
//   state          text
//   zip            text
//   is_member      boolean DEFAULT false
//   member_since   timestamptz
//   created_at     timestamptz DEFAULT now()
//   updated_at     timestamptz DEFAULT now()
//
// RLS: users can select/update where id = auth.uid(). Insert is normally
// handled by a trigger on auth.users insert (using raw_user_meta_data).

import { supabase } from './supabase'

// Fetches the current user's profile. Returns null if the row doesn't exist
// yet (e.g., trigger not set up — first-time fallback path).
export async function getProfile(userId) {
  if (!userId) return null
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .maybeSingle()
  if (error) throw error
  return data
}

// Upserts the profile row. Use when the caller wants to create-or-update in
// one shot (e.g., Signup writes the initial row if the DB trigger isn't
// wired up, and Profile edits update it later).
export async function upsertProfile(userId, partial) {
  if (!userId) throw new Error('upsertProfile: missing userId')
  const payload = { id: userId, ...partial, updated_at: new Date().toISOString() }
  const { data, error } = await supabase
    .from('profiles')
    .upsert(payload, { onConflict: 'id' })
    .select()
    .single()
  if (error) throw error
  return data
}

// Convenience for Members activation.
export async function activateMembership(userId) {
  return upsertProfile(userId, {
    is_member: true,
    member_since: new Date().toISOString(),
  })
}
